import axios from 'axios';

import { GetChartRequestBody, GetChartResponseBody, TChartDataMetric } from '@sparkplug/lib';

const chartRequestPrefix = '/api/v1/sparkplug/chart';
export default class ChartsAPI {
    static async fetchChart(
        { type }: { type: TChartDataMetric },
        body: GetChartRequestBody,
    ): Promise<GetChartResponseBody> {
        if (type === 'percent_increase') {
            return (await axios.post(`${chartRequestPrefix}/percent_increase`, body)).data;
        }
        return (await axios.post(`${chartRequestPrefix}/${type}`, body)).data;
    }
}
